import React, { useState } from 'react';



import {
  DashboardStatCardContainer,
  DashboardStatCardContent,
  DashboardStatCardHeader,
  DashboardStatCardIconContainer,
  DashboardStatCardSecondary,
  DashboardStatCardTitle,
  DashboardStatCardValue,
  DashboardStatCardSkeletonTitle,
  DashboardStatCardSkeletonIcon,
  DashboardStatCardSkeletonValue,
  DashboardStatCardSkeletonSecondary,
} from '../../DashBoardNew/dashBoardNewStyles';
import dashboardStatIconHover from '../../../assets/img/icons/dashboradStatIconHover.svg';

const DashboardStatCard = ({
  title,
  value,
  secondaryText = "",
  icon,
  containerProps = {},
  handleIconClick,
  isLoading,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const renderIcon = () => {
    if (!icon) return null;

    const iconSrc = isHovered ? dashboardStatIconHover : (typeof icon === 'string' ? icon : null);

    if (typeof iconSrc === 'string') {
      return <img src={iconSrc} alt={`${title} icon`} />;
    }

    return icon;
  };

  // Render skeleton loading state
  if (isLoading) {
    return (
      <DashboardStatCardContainer {...containerProps}>
        <DashboardStatCardHeader>
          <DashboardStatCardSkeletonTitle />
          {icon && <DashboardStatCardSkeletonIcon />}
        </DashboardStatCardHeader>

        <DashboardStatCardContent>
          <DashboardStatCardSkeletonValue />
          {secondaryText && <DashboardStatCardSkeletonSecondary />}
        </DashboardStatCardContent>
      </DashboardStatCardContainer>
    );
  }

  return (
    <DashboardStatCardContainer {...containerProps}>
      <DashboardStatCardHeader>
        <DashboardStatCardTitle>{title}</DashboardStatCardTitle>
        {icon && (
          <DashboardStatCardIconContainer 
            onClick={handleIconClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {renderIcon()}
          </DashboardStatCardIconContainer>
        )}
      </DashboardStatCardHeader>

      <DashboardStatCardContent>
        <DashboardStatCardValue>{value}</DashboardStatCardValue>
        {secondaryText && (
          <DashboardStatCardSecondary>{secondaryText}</DashboardStatCardSecondary>
        )}
      </DashboardStatCardContent>
    </DashboardStatCardContainer>
  );
};

export default DashboardStatCard;